const UrlGenerator = () => {
  const appRoot = () => __CONFIG__.appUrl;
  const signupRoot = () => __CONFIG__.signupUrl;

  return { appRoot, signupRoot };
};

export default UrlGenerator;
